import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { languageChange } from 'store/siteConfig'

// ------------------------------------
// Constants
// ------------------------------------
export const COUPON_USE = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  QUERY_RESULT_REQUEST: null,
  QUERY_RESULT_SUCCESS: null
}, 'COUPON_USE')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: '/cgs/api/coupon/coupon-list/v1/auth/generate-code',
        method: 'POST',
        body: data,
        requestAction: COUPON_USE.INIT_REQUEST,
        successAction: COUPON_USE.INIT_SUCCESS,
        success: function(result) {
          dispatch(queryResult(data, 60))
        }
      })
    )
  }
}

export function queryResult(data, count) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: '/cgs/api/coupon/writeoff/v1/auth/query-result',
        method: 'POST',
        body: data,
        requestAction: COUPON_USE.QUERY_RESULT_REQUEST,
        successAction: COUPON_USE.QUERY_RESULT_SUCCESS,
        success: function(result) {
          if (count === 0 || result.status === 'SUCCESS') { // TODO 失败？
            return
          }
          setTimeout(() => {
            count--
            dispatch(queryResult(data, count))
          }, 5000)
        }
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [COUPON_USE.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [COUPON_USE.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
  [COUPON_USE.QUERY_RESULT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [COUPON_USE.QUERY_RESULT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload)
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'couponUse',
    reducerMap: {
      couponUseState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)],
    // Actions to fire when this module is added/removed
    initialActions: [languageChange('en')],
    // finalActions: []
  }
}
